module.exports = __webpack_public_path__ + "img/introducePageFour_show_five.ae9ea64b.jpg";